import { render, staticRenderFns, recyclableRender, components } from "./couponItme.vue?vue&type=template&id=0d6a04c8&scoped=true&"
var renderjs
import script from "./couponItme.vue?vue&type=script&lang=js&"
export * from "./couponItme.vue?vue&type=script&lang=js&"
import style0 from "./couponItme.vue?vue&type=style&index=0&id=0d6a04c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a04c8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/coupon/couponItme.vue"
export default component.exports